import {ViewPopupLanguage} from '../ui_popup/ViewPopupLanguage.ts'
import {MorePageContainer} from '@colonist/ui-platform'
import {navigateToPage} from '../ui_utils/ClientUtils.ts'
import {mountUIReactComponent} from '../ui_platform/mountUIReactComponent.tsx'

export function mountMorePage(containerId: string, onRulebookClick: () => void) {
    mountUIReactComponent(containerId, MorePageContainer).render({
        onNavigate: (path: string) => navigateToPage(path, false, true),
        onExternalNavigate: (url: string) => navigateToPage(url, true),
        onLanguageClick: () => new ViewPopupLanguage(),
        onRulebookClick: onRulebookClick,
    })
}
